import React, { useMemo } from 'react'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import { sum } from 'lib/array/arrayUtils'

interface Props {
  variants?: Array<App.MerchandiseOfferVariant>
}

const MIN_INVENTORY = 5

function MerchandiseLowStockLabel({ variants }: Props) {
  const totalInventory = useMemo(
    () => sum(variants?.map(variant => variant.inventory) ?? []),
    [variants],
  )

  const isLowInventory = useMemo(
    () => !!totalInventory && totalInventory <= MIN_INVENTORY,
    [totalInventory],
  )

  if (!isLowInventory) {
    return null
  }

  return <UrgencyLabel variant="critical2">
    {totalInventory} left in stock
  </UrgencyLabel>
}

export default MerchandiseLowStockLabel
